/**
 * Runs `fn` once the host page's own load is complete — right away when it already is.
 *
 * Nothing this loader puts on a page may hold the page's load event. The launcher's picture, the bubble
 * stylesheet, a campaign's image, the config request's answer: every one of them counts towards `load`
 * when it is started before it, and the browser's tab keeps its spinner turning until the last of them
 * is in. A visitor reads that spinner as the site being slow, and the site's owner reads it as the widget
 * making it slow — the one impression an embed must never leave. Waiting for `load` is what every
 * established embed does, and it costs the launcher nothing visible: the page paints long before its
 * load completes.
 *
 * `complete`, not `interactive`: `interactive` fires while images and stylesheets are still coming in,
 * and those are exactly what the spinner waits for. The check comes first because a snippet may be
 * inserted long after the page loaded (a tag manager, a consent tool firing on acceptance) — `load` has
 * fired for good then, and a listener alone would wait forever.
 * @param {() => void} fn - What to run
 */
export function afterPageLoad(fn) {
    if (document.readyState === 'complete') {
        fn();
        return;
    }

    window.addEventListener('load', fn, { once: true });
}
